import { BE_USER_SERVICE_URL } from '.';

const AUTH_API_URL = {
  REFRESH: `${BE_USER_SERVICE_URL}/auth/refresh`,
};

export default AUTH_API_URL;
